module.exports = __webpack_public_path__ + "img/flight.b0dc7ae9.svg";